<template>
    <div class="gs-webhook">
        <affiliate-workspace :sections="pricePointsTabs" :current="pricePointsTab" :error-sections="webhookPricePointsErrorTabs" label="Price points" @select="handlePricePointsTabChange">
        <div class="bg-white rounded p-2 mb-2 gs-webhook__surface">
            <div v-for="(pricePoint, index) in localWebHook.price_points" :key="index">
                <div v-if="pricePointsTab ===
                    'data_sharing_product_price_point_' + pricePoint.id
                    " class="flex flex-col w-full gs-webhook__selected-point">
                    <div class="flex flex-row-reverse w-full gs-webhook__actions">
                        <gd-button size="auto" variant="primary" class="gs-webhook__add" @click="addIPNURL(index)">
                            {{
                                $t(
                                    'frontend_product_step8_no_integrations_add_new_webhook'
                                )
                            }}
                        </gd-button>
                    </div>

                    <div class="flex flex-col w-full bg-white mb-2 gs-webhook__records">
                        <div v-if="pricePoint.ipnUrl && pricePoint.ipnUrl.length > 0" class="mt-6 gs-webhook__record-list">
                            <div v-for="(ipn_Url, ipnIndex) in pricePoint.ipnUrl" :key="ipnIndex"
                                class="flex flex-col w-full mb-6 gs-webhook__record">
                                <div class="gs-webhook__field">
                                    <label class="font-semibold text-sm text-grey-700 mb-2 gs-webhook__field-label">{{
                                        $t('frontend_product_step8_webhook_url')
                                    }}</label>
                                    <div class="w-full gs-webhook__input">
                                        <text-input v-model="ipn_Url.link"
                                            :validator="validator.webhook.price_points.$each[index].ipnUrl.$each[ipnIndex].link"
                                            attribute="IPN URL" value="ipn_Url.link"
                                            :placeholder="$t('frontend_product_step8_ipn_url')" />
                                    </div>
                                </div>
                                <gd-button variant="outline" size="iconlg" class="ml-2 gs-webhook__delete" :title="$t('frontend_delete')" :aria-label="$t('frontend_delete')"
                                    @click="deleteIPNURL(index, ipnIndex)">
                                    <trash-icon class="w-5 h-5 fill-current" />
                                </gd-button>
                            </div>
                        </div>
                        <div v-else class="mt-6 gs-webhook__empty">
                            <label class="text-grey-dark">{{
                                $t('frontend_product_step8_no_webhook')
                            }}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </affiliate-workspace>
    </div>
</template>
<style scoped>
.gs-webhook__surface {
    padding: 8px;
}

.gs-webhook__actions {
    margin-bottom: 16px;
}

.gs-webhook__add {
    min-height: 2.75rem;
    color: var(--gs-primary);
    background: var(--gs-surface);
    border-color: var(--gs-primary);
    box-shadow: none;
}

.gs-webhook__add:hover {
    color: var(--gs-primary);
    background: var(--gs-primary-soft);
    border-color: var(--gs-primary);
}

.gs-webhook__record-list {
    display: grid;
    gap: 12px;
}

.gs-webhook__record {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 2.75rem;
    gap: 12px;
    align-items: end;
    max-width: 56rem;
    padding: 12px;
    background: var(--gs-surface-subtle);
    border: 1px solid var(--gs-border);
    border-radius: var(--gs-radius-md);
}

.gs-webhook__field,
.gs-webhook__input {
    min-width: 0;
    margin: 0;
}

.gs-webhook__field-label {
    display: block;
    margin-bottom: 8px;
    color: var(--gs-foreground);
}

.gs-webhook__input ::v-deep > div {
    height: auto;
    min-width: 0;
}

.gs-webhook__input ::v-deep input {
    height: 2.75rem;
    min-height: 2.75rem;
    min-width: 0;
}

.gs-webhook__delete {
    width: 2.75rem;
    min-width: 2.75rem;
    height: 2.75rem;
    min-height: 2.75rem;
    margin-left: 0;
    color: var(--gs-danger);
    background: transparent;
    border-color: transparent;
    box-shadow: none;
}

.gs-webhook__delete:hover {
    color: var(--gs-danger);
    background: var(--gs-surface-subtle);
    border-color: var(--gs-danger-border);
}

.gs-webhook__add:focus-visible,
.gs-webhook__delete:focus-visible,
.gs-webhook__input ::v-deep input:focus-visible {
    outline: 2px solid var(--gs-primary);
    outline-offset: 2px;
}

@media (max-width: 40rem) {
    .gs-webhook__surface {
        padding: 12px;
    }

    .gs-webhook__record {
        width: 100%;
        max-width: none;
    }

    .gs-webhook__input ::v-deep input {
        height: 2.75rem;
    }
}
</style>
<script>
import AffiliateWorkspace from '../../components/AffiliateWorkspace.vue';
import TrashIcon from '@/assets/images/icons/TrashIcon.svg';

export default {
    components: { AffiliateWorkspace,
        TrashIcon,
    },
    props: {
        webhook: {
            type: Object,
            required: true,
        },
        pricePointsTabs: {
            type: Array,
            required: true,
        },
        pricePointsTab: {
            type: String,
            required: true,
        },
        webhookPricePointsErrorTabs: {
            type: Array,
            required: true,
        },
        validator: {
            type: Object,
            required: true,
        },
        handlePricePointsTabChange: {
            type: Function,
            required: true,
        },

    },
    data() {
        return {
            localWebHook: this.webhook
        }
    },
    watch: {
        localWebHook: {
            handler: function (val, oldVal) {
                this.$emit('update-data', {
                    key: 'webhook',
                    value: val,
                });
            },
            deep: true,
        },
    },
    methods: {
        addIPNURL(index) {
            this.localWebHook.price_points[index].ipnUrl.push({ link: '', type: 1 });
        },
        deleteIPNURL(index, ipnIndex) {
            this.localWebHook.price_points[index].ipnUrl.splice(ipnIndex, 1);
        },
    }
}
</script>
